import { Component } from '@theme/component';

// <video> selects media-scoped sources when loading, not when resizing.
class EchtHeroVideo extends Component {
  #breakpoint;
  #visibility;

  connectedCallback() {
    super.connectedCallback();
    this.#breakpoint = window.matchMedia('(min-width: 750px)');
    this.#breakpoint.addEventListener('change', this.#selectSource);
    window.addEventListener('pageshow', this.#resume);
    document.addEventListener('visibilitychange', this.#resume);
    this.#visibility = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.#resume();
    });
    this.#visibility.observe(this);
    this.#selectSource();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#breakpoint?.removeEventListener('change', this.#selectSource);
    window.removeEventListener('pageshow', this.#resume);
    document.removeEventListener('visibilitychange', this.#resume);
    this.#visibility?.disconnect();
  }

  // Safari can restore a paused video from its back/forward cache without
  // reconnecting this component or running native autoplay again.
  #resume = () => {
    const video = this.querySelector('video');
    if (!video?.autoplay || !video.paused || document.visibilityState !== 'visible') return;
    const bounds = video.getBoundingClientRect();
    if (bounds.width <= 0 || bounds.height <= 0 || bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
    video.muted = true;
    video.playsInline = true;
    // User autoplay restrictions still apply; rejection must not become an
    // unhandled promise or cause repeated playback attempts.
    video.play()?.catch(() => {});
  };

  #selectSource = () => {
    const video = this.querySelector('video');
    if (!video?.currentSrc) return;
    const source = [...video.querySelectorAll('source[media]')].find(
      (candidate) => window.matchMedia(candidate.media).matches
    );
    if (source && video.currentSrc !== source.src) video.load();
  };
}

if (!customElements.get('echt-hero-video')) {
  customElements.define('echt-hero-video', EchtHeroVideo);
}
